<nav aria-label="page" [class.hide]="totalSearchItems<=10">
    <div class="pagination">
      <div class="page-item" [class.disabled]="SearchCurrentPage === 1">
        <button class="page-link" (click)="changePage(SearchCurrentPage - 1)">Prev</button>
      </div>
      <div class="page-item" *ngFor="let page of pages" [class.active]="page === SearchCurrentPage">
        <button class="page-link" (click)="changePage(page)">{{ page }}</button>
      </div>
      <div class="page-item" [class.disabled]="SearchCurrentPage === totalPages">
        <button class="page-link" (click)="changePage(SearchCurrentPage + 1)">Next</button>
      </div>
    </div>
  </nav>
  